import type { Preferences } from '@smysly/shared';

export function Settings({ preferences, onChange, onClose }: { preferences: Preferences; onChange(patch: Partial<Preferences>): Promise<void>; onClose(): void }): React.JSX.Element {
  return (
    <div className="modal-backdrop" onPointerDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="settings" role="dialog" aria-modal="true" aria-labelledby="settings-title">
        <div className="inspector__top"><div><p className="eyebrow">Мир</p><h2 id="settings-title">Настройки</h2></div><button className="icon-button" onClick={onClose} aria-label="Закрыть">×</button></div>
        <Toggle label="Звуки касаний" checked={preferences.sound} onChange={(sound) => void onChange({ sound })} />
        <Toggle label="Фоновое звучание" checked={preferences.ambient} onChange={(ambient) => void onChange({ ambient })} />
        <Toggle label="Тактильный отклик" checked={preferences.haptics} onChange={(haptics) => void onChange({ haptics })} />
        <hr />
        <Toggle label="Показывать названия моих смыслов другим" checked={preferences.publicMeanings} onChange={(publicMeanings) => void onChange({ publicMeanings })} />
        <p className="settings__note">Ваши ответы и объяснения никогда не показываются другим игрокам.</p>
        <div className="consent-card">
          <p className="eyebrow">Обезличенный след</p>
          <h3>Оставить в этом мире мой след</h3>
          <p>Другие игроки смогут видеть движение вашего анонимного призрака и игровые действия. Они не увидят сообщения, имя, username и Telegram ID.</p>
          <Toggle label="Я согласен оставить след" checked={preferences.ghostConsent} onChange={(ghostConsent) => void onChange({ ghostConsent })} />
        </div>
      </section>
    </div>
  );
}

function Toggle({ label, checked, onChange }: { label: string; checked: boolean; onChange(value: boolean): void }): React.JSX.Element {
  return <label className="toggle"><span>{label}</span><input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} /><i /></label>;
}
